import React from 'react'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../../analytics/utils/firebaseUtils'

interface Props {
	time: any
	disableYear?: boolean
}

const ChartTimeSwitch: React.FC<Props> = ({ time, disableYear }) => {
	const { t } = useTranslation('pages_electricity')

	const span = time.span ?? time.activeTimespan

	const setTimeSpan = (span: string) => {
		logEvent(`click-chart-change-time-span`, { value: span })
		time.setSpan(span)
	}

	const defaultStyle =
		'option text-[#a3a3a3] dark:text-brand-primary-100-dark bg-white dark:bg-[#144448] hover'
	const selectedStyle =
		'option bg-brand-secondary-100-light text-white dark:bg-[#3cb49f] dark:text-background-200-dark cursor-default'

	return (
		<div className='switch-container bg-brand-secondary-200-light dark:bg-[#0d2d30] border border-[#d7d7d7] dark:border-[#063a3e]'>
			<div className='switch gap-1 bg-white dark:bg-[#144448]'>
				<div
					onClick={() => setTimeSpan('day')}
					className={span === 'day' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.paiva')}
				</div>
				<div
					onClick={() => setTimeSpan('week')}
					className={span === 'week' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.viikko')}
				</div>
				<div
					onClick={() => setTimeSpan('month')}
					className={span === 'month' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.kuukausi')}
				</div>
				{!disableYear && (
					<div
						onClick={() => setTimeSpan('year')}
						className={span === 'year' ? selectedStyle : defaultStyle}
					>
						{t('chartTimeSwitch.vuosi')}
					</div>
				)}
			</div>
		</div>
	)
}
export default ChartTimeSwitch
